import { Route } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import Mailer from './Mailer'

const MailerRoutes = () => [
  <Route
    path="mailer"
    key="mailer"
    element={(
      <RouteGuard requiredRoles={['mailer']}>
        <Mailer />
      </RouteGuard>
    )}
  />
]

export default MailerRoutes